import { Link } from "react-router-dom";
import { ClearCross } from "../ClearCross";

export const MobileClearCross = () => (
  <div className="flex flex-col" style={{ height: "100dvh" }}>
    <div className="p-2 flex-none">
      <Link to="/mobile" className="btn btn-default">To Menu</Link>
    </div>
    <div className="flex-1 min-h-0 overflow-hidden">
      <ClearCross />
    </div>
  </div>
);
